import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import { useSelector } from "react-redux";
import { Box, Button, Fab, ListItemIcon, Typography } from "@mui/material";
import { useState } from "react";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import { useApi } from "../hooks";
import { apiLogutUser, method } from "../apiPath";
import { getToast } from "../common/utils";
import keyNames from "../keyName";
const toast = getToast("error");
const Header = ({ open, setOpen }) => {
  const storeData = useSelector((state) => state.mainReducer);
  const { themeMode } = storeData;

  const hitApi = useApi();
  const [anchorEl, setAnchorEl] = useState(null);
  const show = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const logOut = () => {
    hitApi(apiLogutUser, null, method.post, keyNames.userData, toast);
  };

  return (
    <AppBar position="fixed" elevation={0} sx={{ bgcolor: "#050530" }}>
      <Toolbar
        sx={{
          paddingLeft: "16px !important",
          paddingRight: "16px !important",
        }}
      >
        <Button
          variant=""
          sx={{
            mr: 2,
            p: 0.7,
            minWidth: "auto",
            color: "#fff",
          }}
          onClick={() => setOpen(!open)}
        >
          <MenuIcon />
        </Button>
        <Box sx={{ flexGrow: 1 }}>
          <Box className="logo">
            <img
              src="/Bharat-Vyapar-Mahotsav.webp"
              alt="Bharat Vyapar Mahotsav"
              style={{ height: 36, width: "auto" }}
            />
          </Box>
        </Box>

        <Fab
          size="small"
          aria-label="profile"
          onClick={handleClick}
          sx={{
            bgcolor: "#c75b0e",
            color: "#fff",
            "&:hover": { bgcolor: "#a94d0b" },
          }}
        >
          <AccountCircle />
        </Fab>

        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          open={show}
          onClose={handleClose}
          sx={{ mt: 1.5 }}
          MenuListProps={{ sx: { minWidth: 150 } }}
        >
          <MenuItem sx={{ py: 1.5 }} onClick={handleClose}>
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            Profile
          </MenuItem>
          <MenuItem sx={{ py: 1.5 }} onClick={logOut}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
